<template>
    <div class="modal-content">
        <div v-if="componentprops" class="modal-information-text">
            <span style="font-size: 20px;">{{trans('visit_done_are_you_sure')}}</span> <p/>
            <span> {{trans("you_have_done")}}: {{componentprops.done_amount}}, {{trans("out_of")}}: {{componentprops.non_gray_amount}} {{trans("checklist_suposed_to_do_this_season")}} </span> <p/>
            <span v-if="componentprops.done_amount == componentprops.non_gray_amount"> {{trans('amount_of_checklist_matches_count')}} </span>
            <span v-else-if="componentprops.done_amount > componentprops.non_gray_amount"> {{trans('amount_checklist_more_than_count')}} </span>
            <span v-else-if="componentprops.done_amount < componentprops.non_gray_amount"> {{trans('amount_checklist_less_than_count')}} </span>
        </div>
        <div class="modal-content">
            <br>
            <span>{{trans("enter_name_if_you_want")}}</span>
            <input v-model="sign_name" type="text" class="input-field">
        </div>
        <div class="modal-button">
            <!-- <button class="button-box-element btn-agree" @click="$emit('agree', 'sign_name')">{{trans('sign_visit_as_done')}}</button> -->
            <button class="button-box-element btn-agree" @click="emit_func()">{{trans('sign_visit_as_done')}}</button>
            <button class="button-box-element btn-close" @click="$emit('disagree')">{{trans('back')}}</button>
        </div>
    </div>
</template>

<script>

export default {
	name: "confirmModal",
	props: ["componentprops"],
	data() {
		return {
            sign_name: ""
		}
	},
	methods: {
        emit_func(){
            console.log("emmiting: ",this.sign_name)
            this.$emit("agree",this.sign_name)
        }
	}
};
</script>
<style scoped>
    .modal-button {
        display: flex;
        justify-content: space-between;
    }
    .button-box-element {
        width: 130px;
        background-color: #1B608C;
        color: #FFFFFF;
        height: 28px;
        width: 200px;
        border-radius: 28px;
        border: none;
        margin-top: 8px;
    }
    .button-box-element:hover {
        cursor: pointer;
    }
    .btn-agree {
        background-color: #1B608C;

    }
    .btn-close {
        background-color: #ECEDF0;
        color: black;
    }
    .btn-close:hover {
        background-color: #E16369;
        color: white;
    }
    button {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }
</style>